
export enum ROLE {
  Organisation= 0, OrganisationalRepresentative= 1,
  Accountant= 2, IndividualClient= 3, BookingOfficer= 4, Administrator= 5,
  Interpreter= 6, NONE = 7
}



// WEBPACK FOOTER //
// ./src/app/shared/model/role.enum.ts